import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderService } from '@ff/loader';
import { UploadEmployeesService } from 'src/app/services/shared/upload-employees.service';
import { UtilsService } from 'src/app/services/shared/utils.service';
import { DialogLogsComponent } from '../dialog-logs/dialog-logs.component';

@Component({
  selector: 'app-dialog-import-history',
  templateUrl: './dialog-import-history.component.html',
  styleUrls: ['./dialog-import-history.component.scss']
})
export class DialogImportHistoryComponent {
	history: any;
	country_name: string;
  title:string ="Import history";
	//displayedColumns: string[] = ['date', 'userid', 'email' ,'logs','download'];
  displayedColumns: string[] = ['date', 'userid', 'email','filename' ,'logs','download'];

  constructor(
    public dialogRef: MatDialogRef<DialogImportHistoryComponent>,
    private uploadFileService: UploadEmployeesService,
    private utilsService: UtilsService,
    private loaderService: LoaderService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.history = data.history;
	  this.country_name = data.country_name;
  }

  onClose(): void {
    this.dialogRef.close();
  }
  onDownload(item: any): void {
    this.exportImportedFile(item);
  }

  onOpenLogs(item: any): void {

    
 
    this.openLogDialog(item);
  }

  exportImportedFile(item: any): void {
		this.loaderService.show();

		this.uploadFileService.exportImportedFile(item.id).subscribe((res) => {

      //recuperer filename from item.filename that is a path
      const filename = item.filename.split('/').pop();

			this.utilsService.exportFileHistoryXlsx(res, filename);
			this.loaderService.hide();
		}, error => {
			this.loaderService.hide();
			this.snackBar.open(error);
		});
	}

    openLogDialog(item): void {
      const dialogRef = this.dialog.open(DialogLogsComponent, {
        width: '1200px',
        data: { item:item }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });
    }
}